import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { StreetSweepingSchedule } from "../models";

interface StreetDatasetContextProps {
  dataset: Array<StreetSweepingSchedule>;
}

export const StreetDatasetContext = createContext<StreetDatasetContextProps>({
  dataset: [],
});

export const StreetDatasetContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [dataset, setDataset] = useState<StreetSweepingSchedule[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const response = await fetch("./streetData.json");
        const streetData = await response.json();
        setDataset(streetData);
      } catch (error) {
        console.log("Error Reading data: ", error);
        setDataset([]);
      }
    })();
  }, []);

  return (
    <StreetDatasetContext.Provider value={{ dataset }}>
      {children}
    </StreetDatasetContext.Provider>
  );
};

export const useStreetDataset = (): StreetDatasetContextProps => {
  const datasetContext = useContext(StreetDatasetContext);
  if (datasetContext === undefined) {
    throw new Error("No dataset context");
  }
  return datasetContext;
};
